import React, { useState } from 'react';
import MapView from './MapView';
import Legend from './Legend';
import mapData from './data.js';
import LegendMobile from './LegendMobile';

import './styles.scss';
import MenuBar from './MenuBar';

function InteractiveMap() {
  const [activeMap, setActiveMap] = useState('tang-tret');
  const handleMapChange = (mapId) => {
    setActiveMap(mapId);
  };
  const currentData = mapData[activeMap];

  if (!currentData) return null;

  return (
    <div className="container-interactivev2">
      <MapView hotspots={currentData.hotspots} />
      <Legend items={currentData.legend} />
      <LegendMobile
        items={currentData.legend}
        activeMap={activeMap}
        onMapChange={handleMapChange}
      />
      <MenuBar activeMap={activeMap} onMapChange={handleMapChange} />
    </div>
  );
}

export default InteractiveMap;
